import MonitoringSynchroController from './monitoring.synchro.controller';

export default {
    template: require('./monitoring.synchro.html'),
    controller: MonitoringSynchroController
};
